import { render, staticRenderFns } from "./V6SlideKid.vue?vue&type=template&id=4fa78ba0&scoped=true&"
import script from "./V6SlideKid.vue?vue&type=script&lang=js&"
export * from "./V6SlideKid.vue?vue&type=script&lang=js&"
import style0 from "./V6SlideKid.vue?vue&type=style&index=0&id=4fa78ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa78ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})
